<template>
    <CustomDialog v-model="visible" :defaultTitle="$t('staff_planning_v3.send_modal.title')" width="560px">
        <!-- CONTENT -->
        <template #content>
            <div class="ppv2-space-y-6">
                <PlanningTypeSelector
                    :selected-week="selectedWeek"
                    :type.sync="sendForm.type"
                    :week-str="sendForm.weekStr"
                    :can-show-month="canShowMonth"
                    :enabled-weeks-month-count="enabledWeeksMonthCount"
                    :enabled-weeks-perso-count="enabledWeeksPersoCount"
                />

                <WeekSelector
                    v-if="sendForm.type === 'month'"
                    :title="$t('staff_planning_v3.main.published_upcoming_weeks')"
                    :weeks="nextMonthWeeks"
                    :selected.sync="sendForm.weeks"
                />

                <WeekSelector
                    v-if="sendForm.type === 'custom'"
                    :title="$t('staff_planning_v3.main.personalized_weeks')"
                    :weeks="personalizedWeeks"
                    :selected.sync="sendForm.weeks"
                />

                <StaffSelector :staffs="modalStaffList" :selected.sync="sendForm.staffs" />

                <NoteSection v-model="sendForm.note" />
            </div>
        </template>

        <!-- ACTIONS -->
        <template #actions>
            <ModalActions
                @cancel="closeModal"
                @confirm="sendPlanning"
                :type="'send'"
                :confirmLabel="$t('staff_planning_v3.components.send_planning.send')"
            />
        </template>
    </CustomDialog>
</template>

<script>
import PlanningTypeSelector from './PlanningTypeSelector.vue'
import WeekSelector from './WeekSelector.vue'
import StaffSelector from './StaffSelector.vue'
import NoteSection from './NoteSection.vue'
import ModalActions from './ModalActions.vue'
import CustomDialog from '../../../Shared/CustomDialog.vue'

export default {
    components: {
        PlanningTypeSelector,
        WeekSelector,
        StaffSelector,
        NoteSection,
        ModalActions,
        CustomDialog,
    },

    props: {
        value: Boolean,
        sendForm: Object,
        nextMonthWeeks: Array,
        personalizedWeeks: Array,
        modalStaffList: Array,
        canShowMonth: {
            type: Boolean,
            default: true,
        },
        enabledWeeksMonthCount: {
            type: Number,
            default: 0,
        },
        enabledWeeksPersoCount: {
            type: Number,
            default: 0,
        },
        selectedWeek: {
            type: String,
            default: '',
        },
    },

    emits: ['input'],

    methods: {
        closeModal() {
            this.$emit('input', false)
        },
        sendPlanning() {
            this.$emit('send')
        },
    },
    computed: {
        visible: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            },
        },
    },
}
</script>
